// extracted by mini-css-extract-plugin
export default {"overlay":"Ly-z","bodyOpen":"My-z","content":"Ny-z","header":"Oy-z","close":"Py-z","closeNoHeading":"Qy-z"};